import { useState, useEffect } from 'react';
import { supabase, RetailerSource } from './supabase';

export function useRetailers() {
  const [retailers, setRetailers] = useState<RetailerSource[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadRetailers() {
      try {
        setLoading(true);
        setError(null);

        const { data, error } = await supabase
          .from('retailer_sources')
          .select('*')
          .eq('enabled', true)
          .order('sort_order');

        if (error) {
          console.error('Error loading retailers:', error);
          setError(error.message);
          return;
        }

        setRetailers(data || []);
      } catch (err) {
        console.error('Retailer loading error:', err);
        setError(err instanceof Error ? err.message : 'Failed to load retailers');
      } finally {
        setLoading(false);
      }
    }

    loadRetailers();
  }, []);

  return { retailers, loading, error };
}

// Helper function to generate retailer search URLs
export function getRetailerUrl(template: string, brand: string, blendName: string): string {
  const query = encodeURIComponent(`${brand} ${blendName}`);
  return template.replace('{query}', query);
}
